<template>
    <div class="privacy-page">

        <div class="privacy-content">
            <h1 style="text-align:center;padding-top: 5%;">
                <span>隐私政策</span>
            </h1>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                【2024年10月01日】更新
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                【2024年10月01日】生效
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                引言
            </p>
            <p class="MsoNormal">
                <span>本隐私政策是合宙通信公司（指上海合宙通信科技有限公司，下同，以下简称</span><span>“合宙通信公司”或“我们”）所有产品和服务统一适用的一般性隐私条款，如我们的具体产品和服务单独的隐私政策与本政策有不一致的，以具体产品和服务单独的隐私政策为准。</span>
            </p>
            <p class="MsoNormal">
                我们重视用户个人信息的保护，您在使用我们产品和服务时，经您允许后我们可能会使用您的相关信息。我们希望通过本政策向您说明，<span>您提供</span>的信息、<span>提供的</span>方式、<span>提供的</span>范围、<span>您提供</span>这些信息的用途、我们及您如何保护这些信息的安全等。请您在使用我们所有产品及服务前，仔细阅读本政策（尤其是加粗的内容）并确定了解我们对您个人信息的处理规则。如您对本隐私政策有任何疑问，可联系我们进行咨询，如您不同意本隐私政策中的任何条款，您应立即停止使用我们产品和服务。<span>如</span>您选择使用或在我们更新本隐私政策后继续使用我们产品和服务，视为您同意我们按本政策使用、保存和共享您的相关信息。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                一、<span>您可能需要提供</span>的个人信息
            </p>
            <p class="MsoNormal">
                二、<span>您</span>个人信息的用途及使用规则
            </p>
            <p class="MsoNormal">
                三、个人信息的共享、转让及披露
            </p>
            <p class="MsoNormal">
                <span>四、</span><span>Cookie</span><span>和同类技术</span>
            </p>
            <p class="MsoNormal">
                五、我们的信息安全保护
            </p>
            <p class="MsoNormal">
                六、您对个人信息的管理
            </p>
            <p class="MsoNormal">
                七、未成年人信息保护
            </p>
            <p class="MsoNormal">
                八、个人信息存储地点及期限
            </p>
            <p class="MsoNormal">
                九、本政策的适用范围
            </p>
            <p class="MsoNormal">
                十、本政策的修订及法律适用
            </p>
            <p class="MsoNormal">
                十一、关键词定义
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                一、<span>您可能需要提供</span>的个人信息
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>本政策有关个人信息、个人敏感信息的内容出自于</span><span>GB/T35273</span><span>《个人信息安全规范》的规定，定义与</span><span>GB/T35273</span><span>《个人信息安全规范》定义一致。对个人敏感信息，我们用“加粗”的书写方式进行特别提醒，希望您在阅读时特别关注。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>您提供</span>个人信息的主要来源有：您主动向我们提供的信息、您使用我们产品或服务过程中<span>提供</span>的信息、第三方分享的您的信息。我们会出于如下产品功能之目的使用您的个人信息，如您不提供相关信息或不同意我们<span>使用</span>相关信息，您可能无法注册成为我们的用户或无法享受我们提供的某些服务，或无法达到好的服务效果。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b><span>1. </span><span>您</span></b><b><span>直接</span></b><b>提供的信息</b><b></b>
            </p>
            <p class="MsoNormal">
                <span>1.1 </span><span>为向您提供账号注册、登录功能及服务，可能需要您提供如下账号注册信息：</span>
            </p>
            <p class="MsoNormal">
                一键登录：当您选择使用手机号码一键登录方式登录时，我们会从移动运营商处获取您的手机号码及该号码所属的运营商信息。如您不使用一键登录功能的，您可以通过本政策中的其他方式进行登录。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                短信验证登录：如您选择此方式登录，您需要输入手机号码及对应验证码，经验证通过后方可登录。我们会<span>使用</span>您所填写的手机号码，用于账号管理及登录验证。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>账号登录：您需要输入您的用户名、电子邮箱或者手机号码及密码以验证您的身份后登录。如果您没有APP账号，可通过手机号码注册账号。当您使用手机号码注册时，我们会向您的手机号码发送短信验证码，您需要向我们提供短信验证码以验证您的身份后方可成功注册。
                    </span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>第三方跳转登录：您可以使用第三方账号登录，主要包括</span><span>QQ</span><span>、微信、微博、手机厂商账号，当您授权使用前述第三方账号登录时，我们会</span><span>使用</span>从第三方账号共享的头像、昵称及其他您在第三方授权登录界面同意授予的信息。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>使用前述这些账号信息的目的在于（</span><span>1</span><span>）通过账号管理更好地为您提供服务，通过登录账号，您可以查看您使用我们的产品或服务的部分信息；在您更换设备后，通过登录账户，可以继续查看使用您已同步的相关信息，不会因为更换设备而导致数据丢失。（</span><span>2</span><span>）如您提供真实有效的手机号码、</span><span>QQ</span><span>号、微博号、微信号或其他第三方账号进行绑定，当您遇到注册账号丢失、忘记密码问题时，可以便捷的找回账号和密码。（</span><span>3</span><span>）为符合相关法律法规实名注册的要求，我们需要您通过手机号或身份证号实名认证后方可使用部分服务。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>1.2 </span><span>您在使用我们的产品和服务时上传的信息或在参加我们举办的活动时向我们提供的信息。</span>
            </p>
            <p class="MsoNormal">
                主要包括：在您使用我们产品购买商品时，为向您发送商品，您向我们提供的联系人、联系地址、联系方式；其他您在使用我们产品和服务时上传的信息，以具体产品或服务的隐私政策为准。前述信息使用的目的是为对应的具体功能的实现，如您不提供相关信息的，对应功能可能无法实现。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>1.3 </span><span>您通过我们的客服所提交的信息。</span>
            </p>
            <p class="MsoNormal">
                <span>您可以通过我们具体产品或服务内的意见反馈渠道向我们提出意见反馈、投诉、申诉或咨询产品或服务相关问题。为了您的账号与系统安全，我们可能需要您提供您注册</span><span>/</span><span>登录时的账号，以便对您的用户身份进行核验。在验证过程中，您可能还需要向我们提供相应的证明材料、您的联系方式，以便我们与您联系并帮助您解决问题，或记录相关问题的处理方案及结果。此外，系统可能会记录您与客服之间的沟通记录，以便能够更好地帮您解决所咨询的问题和改善客服质量。如您不提供上述信息，我们可能无法向您及时反馈咨询的结果，但不影响您正常使用我们的产品或服务。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b>我们如果需要使用您提供的特定个人敏感信息，我们会以显著方式告知并获取您的同意。在您没有同意前，我们不会使用个人信息或者</b><b><span>询问</span></b><b>使用个人信息的权限。若您选择不提供该类信息，则可能无法正常使用对应功能，但不影响您使用服务中的其他功能。</b><b><span>您</span></b><b>表示不同意后，我们不能频繁提示您提供，或擅自打开权限。</b><b><span>您</span></b><b>拒绝后，在不使用相关功能时</b><b><span>不再</span></b><b>弹窗提示</b><b><span>您</span></b><b><span>授权。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。使用</span><span>14</span><span>岁以下未成年人个人信息的，</span></b><b><span>将</span></b><b>征求其监护人同意。</b><b></b>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b><span>2. </span><span>我们在您使用服务时获取的信息</span></b><b></b>
            </p>
            <p class="MsoNormal">
                <span>2.1 </span><span>设备信息</span>
            </p>
            <p class="MsoNormal">
                设备信息。<span>为了保证位置</span>、<span>计步等基础功能</span><span>服务与设备进行必要的适配及提供安全服务，您在使用我们产品或服务时，我们可能会使用您提供的所必需的各类信息。其中包括设备名称、设备型号、设备识别码（主要包括国际移动设备身份码</span><span>IMEI</span><span>、安卓</span><span>ID</span><span>、</span><span>open
                    ID</span><span>、、网络设备硬件</span><span>MAC</span><span>地址、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络</span><span>ID</span><span>（</span><span>PLMN</span><span>）相关信息。</span>
            </p>
            <p class="MsoNormal" style="text-indent:21.0000pt;">
                使用这些信息的目的在<span>于</span><span>向您提供产品和</span><span>/</span><span>或服务，并且保证我们遵守适用法律。使用这些信息是为了保证网络安全或运营安全，帮助我们进行</span><span>bug</span><span>分析，保障您正常使用产品和服务、改进和优化我们的产品体验、保障您的账号安全。这些信息将会被如</span><span>此</span>使用：
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                ●与您就您的设备、服务或任何普通查询（例如更新、客户咨询支持、消息通知）等进行交流。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                ●分析和开发与我们产品及服务的使用相关的统计信息，以更好地改进我们的产品和服务。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                ●储存并维护与您相关的信息，用于我们运营业务或履行法律义务。 <br>
                关于我们如何使用您的信息（其中可能包含个人信息），下面提供了更多详细信息：
            </p>
            <p class="MsoNormal">
                ●验证设备唯一性。当您首次绑定<span>其他硬件</span>时，该硬件的设备唯一识别码、固件版本将被用于验证设备唯一性。上述信息也将用于更新系统或软件、恢复出厂设置等情况。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                ●判断移动终端能否<span>与我们</span><span>app</span><span>运行：目前，</span><span>移动终端</span>应用仅能在特定的操作系统和特定的移动终端上运行。为此，我们需要检测您的移动终端信息。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>●提供基于位置的服务：您使用基于位置信息的程序服务或功能时，我们会使用您提供的设备和</span><span>/</span><span>或手机的地理位置信息，以实现在线或实时（每隔</span><span>20</span><span>秒上报）查看您的目前所在位置以及足迹；您可以查看您的当前位置与设备位置的距离；利用地理位置信息还可以在设备上为您展示当前的天气。当您的</span><span>设备</span>进出<span>您</span><span>设置的安全区域时，我们会向您发送通知。您提供的</span><span>Wi-Fi</span><span>信息还将用于提升</span><span>设备</span>定位精度。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                ●计步功能：<span>您提供的</span>计步信息来为您展示您与您设备的运动详情，您可以以日视图或周视图来查看；您还可以查看您<span>设备</span>的运动步数排名。为此，<span>您可能需要提供</span>计步信息、<span>设备使用者</span>的身高和体重（用于计算卡路里）以及位置信息。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                ●<span>汇总</span>用户反馈：您选择提供的反馈对帮助改进我们的服务而言极为珍贵。为了跟<span>进您</span>提供的反馈，<span>我们</span>可能会使用您所提供的个人信息与您联系，并保留记录。
            </p>
            <p class="MsoNormal">
                请您注意，本产品带有<span>自动接听</span>功能，我们仅建议您在守护<span>设备使用者</span>的情景下使用此类功能。请确保您在使用此类功能时尊重且没有侵犯他人的权利；请确保您已经知悉因在其他场景使用而可能带来的法律后果。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.2</span><span>通信、通话相关信息：</span>
            </p>
            <p class="MsoNormal" style="text-indent:21.0000pt;">
                经您允许后我们会<span>使用</span><span>您设备的网络运营商、</span><span>SIM</span><span>卡号码（手表号码）、移动信号值、手机来电状态、手机来电号码、通讯录（“家庭成员列表”，包括好友的昵称、手表号码、好友列表）、通话记录、通话白名单开关、聊天信息（手机与设备之间通讯的语音）、短信白名单开关。例如，您可以通过拨打设备的</span><span>SIM</span><span>卡号码来进行通话；您还可以通过设置通话白名单来保护</span><span>设备的使用</span>安全；我们使用您的<span>通讯信息</span>、通讯录信息、昵称、头像，来为您提供设备与手机<span>通讯</span><span>的服务；您还可以通过</span><span>App</span><span>的</span><span>自动接听</span>功能单向聆听您的<span>设备</span>，随时倾听<span>设备</span>周边环境。请您放心，您的通讯信息会加密之后存放在服务器；我们不会读取您的<span>通讯</span>信息内容。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                当涉及版本变更或者隐私权限变更，会重新在运行时提示用户。除本政策另有明确约定外，我们也不会将您的设备信息提供给任何第三方。但我们无法保证其他第三方不会通过其他途径获知您设备信息、并将设备信息与其他信息相结合识别您个人身份的情况，由此造成您任何损失的，您应向第三方追偿。上述设备信息是为提供服务所使用的基础信息，如您不想设备信息被我们使用，则可能导致我们无法向您提供<span>对应</span>的服务。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.3 </span><span>位置信息（确定</span><span>app</span><span>实际</span><span>使用</span>没有超出范围）
            </p>
            <p class="MsoNormal">
                位置信息，是指您开启设备定位功能并使用我们基于位置提供的相关服务时，<span>使用</span>有关您位置的信息。<span>例如</span>当您开启设备定位功能并使用我们的地图服务、地理位置同步服务及与位置信息相关的其他服务时，<span>您</span>可能<span>需允许我们通过</span><span>GPS</span><span>、</span><span>WiFi</span><span>或其他技术方式</span><span>汇总</span>和处理有关您所在位置的信息。行踪轨迹、精准定位信息为个人敏感信息，除定位相关的具体产品或服务功能所需外，我们的产品或服务不会使用该类个人敏感信息。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>如您不想被访问，可以选择关闭设备或产品</span><span>/</span><span>服务中的相关功能，但可能会因此影响我们向您提供相关服务。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.4 </span><span>日志信息</span>
            </p>
            <p class="MsoNormal">
                <span>出于服务安全的必要，您使用我们产品和服务时，可能需要允许系统通过</span><span>cookies</span><span>或其他方式</span><span>使用</span><span>某些信息并存储在服务器日志中。此类信息可能包括：</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>1</span><span>）对我们产品和服务的详细使用情况，此种信息可能包括您使用的网页搜索词语、点击记录、访问的页面地址以及您在使用我们服务时浏览记录；用户习惯统计数据，在使用我们产品时的设置项信息、部分按键的使用次数，该类数据都是匿名的，我们无法根据上述数据定位到具体用户。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>2</span><span>）设备或软件信息，除</span><span>2.1</span><span>条所述设备信息外，</span><span>您可能需要提供</span>您使用的软件的版本号、浏览器类型。为确保您操作环境的安全或提供服务所需，<span>您可能需提供</span>有关您使用的移动应用和其他软件的信息。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>3</span><span>）设备事件信息，包括崩溃、系统活动信息及其他相关信息。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>4</span><span>）</span><span>IP</span><span>地址。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b><span>3. </span><span>其他第三方分享或使用的信息</span></b><b></b>
            </p>
            <p class="MsoNormal">
                主要包括两种情况：
            </p>
            <p class="MsoNormal">
                为了给您更便捷的生活服务，我们的产品或服务可能接入了一些第三方服务，您在使用第三方服务时所产生或分享的信息，可能主要涉及如下场景，具体产品或服务中有关第三方分享或使用的信息，以具体产品或服务的隐私政策为准。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>1</span><span>）第三方账号授权登录</span>
            </p>
            <p class="MsoNormal">
                <span>当您使用微博、</span><span>QQ</span><span>、微信账号及其他第三方账号登录我们的产品或服务时，我们需要核实您的身份或绑定您的账户信息，经过您的授权将相关账号关联到我们的产品或服务中。该等信息包括您在第三方账号注册时使用的头像、昵称及其他您在第三方授权登录界面同意授予的信息（主要包括地区、性别信息，具体以您同意且该等第三方</span><span>SDK</span><span>实际提供给本软件的为准）。当您使用移动、联通、电信运营商的手机号一键登录时，我们会从移动运营商（中国联通、中国移动、中国电信）处获取您的手机号码及该号码所属的运营商信息。如您不想前述第三方账号信息被使用，请不要使用第三方账号登录功能。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>2</span><span>）分享功能</span>
            </p>
            <p class="MsoNormal">
                <span>您在使用我们产品或服务中的分享功能时，需要使用第三方</span><span>SDK</span><span>（主要包括微博、微信、</span><span>QQ</span><span>、</span><span>QQ</span><span>空间）进行信息分享，第三方会验证您在第三方的账号信息以实现分享功能。如您不想第三方获得您的相关信息，请不要使用分享功能。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                （3）信息推送服务
            </p>
            <p class="MsoNormal">
                我们需要通过第三方通道为您提供信息推送服务的，第三方通道需要事先获得您的设备信息方可进行推送。如您不想使用推送服务，您可以通过设置中的通知栏消息管理关闭相应通知功能，但可能会因此影响您获得信息推送服务。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b><span>4. </span><span>设备权限调用</span></b><b></b>
            </p>
            <p class="MsoNormal">
                <span>在提供服务过程中</span><span>,</span><span>为了保证您能正常使用产品或服务功能</span><span>,</span><span>我们会向系统申请您的部分设备权限</span><span>,</span><span>您可以选择允许或禁止相关权限申请。您也可以随时在系统设置中取消授权</span><span>,</span><span>您取消授权会导致您无法使用相关业务功能，但不会导致您无法使用其他功能。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                我们的产品或服务可能需要您授权的系统权限主要涉及以下几类，具体以各个产品或服务的隐私政策内容为准：
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <div align="center">
                <table class="MsoTableGrid" border="1" cellspacing="0" style="border:none;">
                    <tbody>
                        <tr>
                            <td width="103" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">设备权限</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="330" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">业务功能</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="118" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">授权是否可关闭</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="103" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">存储</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="330" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">浏览搜索历史、下载文件</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="118" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">是</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="103" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">读取设备信息</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="330" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span
                                        style="font-family:宋体;font-size:9.0000pt;">与设备进行必要的适配、保证产品或服务使用的安全性</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="118" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">是</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="103" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">位置</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="330" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">定位</span><span
                                        style="font-family:Arial;font-size:9.0000pt;">服务</span><span
                                        style="font-family:宋体;font-size:9.0000pt;">、天气服务、地理同步</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="118" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">是</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="103" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">相机</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="330" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:Arial;font-size:9.0000pt;">上传头像</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="118" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">是</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="103" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">麦克风</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="330" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">语音输入</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                            <td width="118" valign="top" style="border:1.0000pt solid windowtext;">
                                <p class="MsoNormal">
                                    <span style="font-family:宋体;font-size:9.0000pt;">是</span><span
                                        style="font-family:Arial;font-size:9.0000pt;"></span>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                二、个人信息的用途及使用规则
            </p>
            <p class="MsoNormal">
                <b>（一）我们主要将信息用作下列用途：</b><b></b>
            </p>
            <p class="MsoNormal">
                <span>1.</span><span>安全保障：在我们提供产品和服务时，用于身份验证、客户服务、安全防范、存档和备份用途，确保我们向您提供的产品和服务的安全性。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                2<span>.</span><span>改善我们现有产品和服务，满足您的个性化需求，提升用户体验。</span>
            </p>
            <p class="MsoNormal">
                如您不希望我们将您的个人信息用作个人性推送或展示，您可以通过对具体产品或服务中的个性化推送开关进行设置，关闭个性化功能，您也可以通过具体产品或服务提供的相关投诉反馈渠道，要求我们停止为上述用途使用您的相关信息。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                3<span>.</span><span>在符合相关法律法规的前提下，我们可能将通过某产品或服务所</span><span>提供</span><span>的个人信息或分析的用户画像，用于我们的其他产品和服务，以便总体上提升为您提供的产品或服务的质量、更好的提供个性化服务、帮助我们设计新产品和服务，或在不透漏您个人信息的前提下对用户数据库进行分析并予以商业化利用，包括但不限于展示广告、基于特征标签进行间接人群画像并提供个性化服务。我们在提供某些产品或服务中，可能会请用户参与</span><span>“用户体验改进计划”，加入用户体验改进计划的用户，我们会根据需要对产品和服务的各项功能使用情况进行统计，这样可以通过分析统计数据提高产品和服务质量，推出对用户有帮助的创新产品和服务。</span><br>
                如您不想参与该计划，可以通过具体产品或服务中的设置项选择关闭该功能或通过我们相关产品或服务提供的反馈渠道向我们反馈。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                4<span>.</span><span>软件认证或管理软件升级。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                5<span>.</span><span>根据法律法规在如下情形使用您的相关信息，此种情况下无须获得您的授权：</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>1</span><span>）与国家安全、国防安全有关的；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>2</span><span>）与公共安全、公共卫生、重大公共利益有关的；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>3</span><span>）与犯罪侦查、起诉、审判和判决执行等有关的；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>4</span><span>）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>5</span><span>）用于维护所提供的产品与</span><span>/</span><span>或服务的安全稳定运行所必需的，包括发现、处置产品与</span><span>/</span><span>或服务的故障等；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>6</span><span>）为合法的新闻报道所必需的；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>7</span><span>）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>8</span><span>）法律法规规定的其他情形。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                6<span>.</span><span>经您同意的其他用途。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b>（二）对您个人信息使用的规则</b><b></b>
            </p>
            <p class="MsoNormal">
                <span>1.
                </span><span>我们会根据本隐私政策的约定并为实现我们的产品与</span><span>/</span><span>或服务功能对您所</span><span>提供</span>的信息进行使用。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.
                </span><span>您提供</span>的个人信息我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息，并在不透露您个人信息的前提下，有权对用户数据库进行分析并予以商业化的利用。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>3.
                </span><span>请您注意，您在使用我们的产品与</span><span>/</span><span>或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝，否则将在您使用我们的产品与</span><span>/</span><span>或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>4.
                </span><span>我们会对我们的产品与</span><span>/</span><span>或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与</span><span>/</span><span>或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>5. </span><span>当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>6. </span><span>当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的用于其他目的时，会事先征求您的同意后再进行使用。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b>（三）我们可能向您发送的信息</b><b></b>
            </p>
            <p class="MsoNormal">
                <span>1. </span><span>信息推送</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                您在使用我们的服务时，我们可能向您发送电子邮件、短信、资讯或推送通知。您可以按照我们的相关提示，在设备上选择取消订阅。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2. </span><span>与服务有关的公告</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                我们可能在必要时（包括因系统维护而暂停某一服务时）向您发出与产品或服务有关的公告。您可能无法取消这些与服务有关、性质不属于广告的公告。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                三、个人信息的共享、转让及披露
            </p>
            <p class="MsoNormal">
                （一）信息的共享
            </p>
            <p class="MsoNormal">
                <span>1.</span><span>我们不会与我们以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>1</span><span>）事先获得您明确的同意或授权；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>2</span><span>）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>3</span><span>）在法律法规允许的范围内，为维护我们或合作伙伴、您或其他我们用户或社会公众利益、财产或安全免遭损害而有必要提供；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>4</span><span>）只有共享您的信息，才能实现我们的产品与</span><span>/</span><span>或服务的核心功能或提供您需要的服务；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>5</span><span>）应您需求为您处理您与他人的纠纷或争议；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                （6）基于学术研究而使用；
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                （7）基于符合法律法规的社会公共利益而使用。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b><span>2.
                    </span><span>为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的内容、保护其他用户或公众的人身财产安全免遭侵害，提升我们整体的产品服务质量，我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。</span></b><b></b>
            </p>
            <p class="MsoNormal">
                <b>&nbsp;</b>
            </p>
            <p class="MsoNormal">
                <b><span>3.
                    </span><span>仅为事先本政策中声明的目的，我们的某些服务将由我们和第三方合作伙伴通过数据接口合作的方式共同提供。我们可能会与合作伙伴共享您的某些信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必须的个人信息。我们的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。目前，此类第三方合作商主要包括：软件服务提供商、智能设备提供商和系统服务提供商、产品功能相关的合作商等。</span></b>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                4<span>.
                </span><span>为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护我们、您或其他我们客户的权利及其财产或安全，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过，这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                5<span>. </span><span>对我们与之共享个人信息的公司、组织和个人，我们会要求其遵守保密约定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b>（二）信息的转让</b><b></b>
            </p>
            <p class="MsoNormal">
                我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>1</span><span>．事先获得您明确的同意或授权；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.</span><span>根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>3.</span><span>符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>4.</span><span>在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则</span><span>,</span><span>我们将要求该公司、组织重新向您征求授权同意。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b>（三）信息的披露</b><b></b>
            </p>
            <p class="MsoNormal">
                我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                1<span>.</span><span>您使用共享功能的；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                2<span>.</span><span>根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件。我们对所有的请求都将进行慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                3<span>.</span><span>在紧急情况下，为了保护您、我们及其他用户的合法权益或公共安全及利益的；</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                4<span>.</span><span>符合我们相关产品和服务的用户协议或其他类似协议的规定。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>四、</span><span>Cookie</span><span>和同类技术</span>
            </p>
            <p class="MsoNormal">
                <span>1.</span><span>什么是</span><span>Cookie</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>Cookie</span><span>是一种可以让网站服务器将数据存储在客户端或从客户端中读取数据的中立技术。</span><span>Cookie</span><span>文件是存储了一些与用户访问网站有关信息的文件，格式为</span><span>.tex</span><span>。</span><span>Cookie</span><span>内容通常均经过加密</span><span>,</span><span>安全的</span><span>Cookie</span><span>技术会为用户在上网时提供更为便捷的服务。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.</span><span>我们使用</span><span>Cookie</span><span>的目的</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>Cookie</span><span>对提升用户的网络使用体验很重要，我们使用</span><span>Cookie</span><span>一般出于以下目的：</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>1</span><span>）身份验证：</span><span>Cookie</span><span>可在您接入我们的服务时通知我们，以使得我们可以验证您的身份信息，确保您的账号安全。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>2</span><span>）偏好设置：</span><span>Cookie</span><span>可帮助我们按照您所希望的服务样式、外观的个性化设置为您提供服务。</span><span>Cookie</span><span>记录您之前设定的字号、分辨率等数值，方便在您再次访问时自动为您调整为之前的设定。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>3</span><span>）安全：</span><span>Cookie</span><span>可帮助我们保障数据和服务的安全性，排查针对我们的产品和服务的作弊、黑客、欺诈等行为。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>4</span><span>）提高效率：</span><span>Cookie</span><span>可以避免不必要的服务器负载，提高服务效率，节省资源。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>5</span><span>）分析和研究：</span><span>Cookie</span><span>可以帮助我们了解、改善我们的产品和服务，为新功能或新产品的研发提供参考数据。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>（</span><span>6</span><span>）广告优化：</span><span>Cookie</span><span>可提高广告对用户的吸引力并提升广告服务对广告主、发布商的价值。</span><span>Cookie</span><span>可帮助我们在软件中向您显示您可能感兴趣的广告，我们的合作伙伴也可能会运用</span><span>Cookie</span><span>确定我们是否已显示广告。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>3.</span><span>如何管理</span><span>Cookie</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>大部分的设备（如使用移动应用程序）和浏览器（如使用网页应用程序和页面）均允许您更改</span><span>Cookie</span><span>设置。这些设置通常位于浏览器的“选项”或“偏好”菜单内，您可以进行设置管理。您也可使用浏览器中的“帮助”选项，以获得更多详细信息。但请注意，如果停用</span><span>Cookie</span><span>，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                五、我们的信息安全保护
            </p>
            <p class="MsoNormal">
                <span>1.</span><span>数据安全技术措施：我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改、避免数据的损坏或丢失；我们将使用安全技术和程序监测、记录网络运行状态、网络安全事件，并采取必要的技术措施保障网络安全，以防信息的丢失、不当使用、未经授权阅览或披露。在某些服务中，我们将利用加密技术、匿名化处理等手段来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的产品和服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.</span><span>我们仅允许有必要知晓这些信息的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>3.</span><span>我们会采取一切合理可行的措施，确保无关的个人信息不被使用。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b><span>4.</span><span>您在使用我们的产品和服务时所提供、上传或发布的内容和信息，可能会泄露您的个人信息。您需要谨慎地考虑，是否在使用我们的产品和服务时披露相关个人信息。在一些情况下，您可通过我们某些产品和服务的隐私设定来控制有权浏览您共享信息的用户范围。</span></b><b></b>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b><span>5.</span><span>互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。由于您将用户密码告知他人、与他人共享注册账户或其他因您个人保管不善，由此导致的任何个人资料泄露、丢失、被盗用或被篡改等产生的责任和损失，您应自行承担。</span></b><b></b>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>6.</span><span>安全事件处理：为应对个人信息泄露、损毁和丢失等可能出现的风险，我们建立了专门的应急响应团队，按照公司有关安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、制定补救措施、联合相关部门进行溯源和打击。同时我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                六、您对个人信息的管理
            </p>
            <p class="MsoNormal">
                <span>1.</span><span>您有权访问、修改、删除您的个人信息；但相关信息的删除或修改可能会影响您对相关产品或服务的使用或导致部分功能无法实现。访问、更正、删除的具体路径一般为：进入具体产品后
                    ，点击“我”，登录后可访问、查看、修改或删除您的账号内信息。您访问、修改和删除个人信息的范围和方式将主要取决于您使用的具体产品和服务。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.</span><span>您有权改变您授权同意的范围或撤回您的授权；您可以通过</span><span>1</span><span>）删除信息、</span><span>2</span><span>）关闭设备功能、</span><span>3</span><span>）在具体产品的网站或软件“设置”中进行隐私设置改变您授权我们继续使用个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续使用您个人信息的授权。请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>3.</span><span>注销账户：您可以通过具体产品或服务设置界面中所公布的注销方式或通过第九条所列联系方式申请注销相关产品账户，我们会根据您的账号安全状态以及产品线信息，判断是否满足注销条件。您注销账户后，我们将停止为您提供与账号相关的产品或服务功能，并将删除或匿名化处理您的个人信息，除法律法规另有规定或您另有要求外。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b><span>4.</span><span>我们将采取适当的技术手段，保证您对于自己的个人资料可进行查询、补充、更正或删除，或通过我们相关产品或服务发布的反馈或投诉渠道申请我们对相关信息进行补充、更正或删除；我们收到您的申请后将按流程（如我们可能会要求您提供相关证明，以确认您的身份）予以处理。请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在合理的期限内答复您的请求。</span></b><b></b>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>5.</span><span>如果您无法访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与</span><span>/</span><span>或服务时所产生的其他个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的使用约定，您可通过第九条所列方式与我们联系。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                七、未成年人信息保护
            </p>
            <p class="MsoNormal">
                <span>1.
                </span><span>我们根据我国法律法规的要求，保护未成年人的个人信息安全。如果您是：（</span><span>1</span><span>）儿童（详情请查阅关键词定义）使用者，必须由您的监护人阅读并同意本协议的全部内容以及《我们儿童隐私保护指引》后，我们方才向您提供我们产品或服务；（</span><span>2</span><span>）已满</span><span>14</span><span>周岁的未成年人使用者，必须由您的监护人陪同阅读本协议的全部内容，并在监护人或您本人同意本协议的全部内容后，我们才向您提供我们产品或服务。如我们有证据证明您违反了上述约定，我们有权停止提供我们的产品或服务。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.
                </span><span>对于经监护人同意而使用未成年人个人信息的情况，我们只会在法律允许、监护人明确同意或者保护未成年人所必要的情况下使用或公开披露该信息。如我们发现在未事先获得监护人同意的情况下使用了被其监护的未成年人的个人信息，我们会尽快删除相关信息。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                八、个人信息存储地点及期限
            </p>
            <p class="MsoNormal">
                <span>1. </span><span>个人信息存储地点：</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                我们会按照法律法规规定，将<span>境内</span>用户个人信息存储在中华人民共和国境内。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2. </span><span>个人信息存储期限：</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>我们仅在本政策所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。具体期限详见各产品和服务单独的隐私政策，如具体的产品和服务未具体列明的，一般情况下，除非法律法规有其他要求，存储期限与您账号有效期限一致，如您属于非注册账户的，则存储期限一般为</span><span>6</span><span>个月。超过前述存储期限后，我们将予以删除或进行不可恢复的匿名化处理。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                但在下列情况下，我们可能因需要符合法律要求，更改个人信息的存储时间：
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                为遵守适用的法律法规等有关规定；为遵守法院判决、裁定或其他法律程序的规定；为遵守相关政府机关或法定授权组织的要求；我们有理由确信需要遵守法律法规等有关规定；为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                当我们的产品或服务发生停止运营的情形时，我们将采取包括但不限于推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                九、本政策的适用范围
            </p>
            <p class="MsoNormal">
                <span>1.
                </span><span>我们所有的产品和服务均适用本政策。针对某些特定产品和服务的特定隐私政策，将在相关产品和服务的使用协议或单独的隐私协议中具体说明。该等特定产品和服务的隐私条款构成本政策的一部分。如相关特定产品和服务的隐私条款与本政策有不一致之处，适用该特定产品和服务的隐私条款。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.
                </span><span>本政策仅适用于我们所使用的信息，并不适用于任何第三方提供的产品和服务或第三方的信息使用规则，您通过我们的产品和服务而接受的第三方产品和服务（包括任何第三方网站）使用的信息，不适用本政策。如您因第三方产品和服务产生的损失，您可以向第三方主张赔偿。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <b><span>3.
                    </span><span>如您在使用我们产品、服务中对本隐私政策有任何问题，您可通过我们相关产品或服务对外公布的官方反馈渠道、个人信息保护负责人的联系方式与我们的具体产品或服务团队联系，您也可以通过拨打+86-186-1625-8958或者寄送相关文件到上海浦东康桥秀沿路100号城置广场6楼611室与我们联系。</span></b><b></b>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                十、本政策的修订及法律适用
            </p>
            <p class="MsoNormal">
                <span>1</span><span>、我们可能适时修订本政策的条款，该等修订构成本政策的一部分。修订后的政策我们将及时予以发布。若您继续使用我们产品和服务，即表示您同意受经修订的隐私政策的约束。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2</span><span>、本政策的解释及争议解决均应适用中华人民共和国法律。与本政策相关的任何纠纷，双方应经友好协商解决；若不能协商解决，您在此同意将争议提交至深圳市宝安区人民法院。如果有管辖权的任何法院裁定或判决本政策的任何条款无效，则该条款将从本政策中移除，该条款的无效不影响本政策其余条款的效力。本政策的其余条款将继续执行。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>3</span><span>、本政策的标题仅为方便阅读而设计，不影响本政策任何条款的含义或解释。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>十一、</span> <span>关键词定义</span>
            </p>
            <p class="MsoNormal">
                <span>1.</span><span>用户或您：指使用我们产品与</span><span>/</span><span>或服务的用户。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>2.</span><span>未成年人：指年龄不超过</span><span>18</span><span>周岁的未成年人。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>3.</span><span>儿童：指未满</span><span>14</span><span>周岁的未成年人。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>4.</span><span>去标识化：指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别您的过程。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>5.</span><span>匿名化：指通过对个人信息的技术处理，使得您无法被识别，且处理后的信息不能被复原的过程。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
            <p class="MsoNormal">
                <span>6.</span><span>设备：指可用于访问我们产品或服务的装置。</span>
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>

        </div>
    </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

</script>

<style scoped lang="scss">
.privacy-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
//   background: #fff;  //不给这个页面背景色，跟随全局模式
}

.privacy-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border-bottom: 1px solid #eee;
    background: #fff;
    z-index: 10;
}

.back-button {
    position: absolute;
    left: 16px;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 12px;
    background: transparent;
    border: none;
    color: var(--color-primary, #409eff);
    font-size: 16px;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.8;
    }

    &:active {
        opacity: 0.6;
    }
}

.title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.privacy-content {
    flex: 1;
    overflow: auto;
    padding: 0px 20px;

}
</style>
